/**
 * Labstep
 *
 * @module components/AccessKey/Form/Create
 * @desc Form to create AccessKey
 */

import {
  accessKeyFieldExpiresAt,
  accessKeyFieldName,
} from 'labstep-web/components/AccessKey/Form/fields';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import { AccessKey } from 'labstep-web/models/access-key.model';
import type React from 'react';
import type { AccessKeyFormCreateProps } from './types';

export const AccessKeyFormCreate: React.FC<
  AccessKeyFormCreateProps
> = ({ options }) => (
  <FormCreate
    entityName={AccessKey.entityName}
    fields={[accessKeyFieldName, accessKeyFieldExpiresAt]}
    options={options}
    autoFocus
  />
);
